import styled from "styled-components"

export const StyledMintModal = styled.div`
  // width: 40vw;
  min-height: 20vh;
  display: flex;
  flex-direction: column;
  width: 30rem;
  max-width: 30rem;
  background: ${({ theme }) => theme.backgroundDark};

  @media (max-width: ${({ theme }) => theme.mobile}) {
    max-width: 90vw;
    min-width: 90vw;
  }
`

export const ModalContentBackground = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.background};
`

export const ModalContentHolder = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  width: 100%;
  text-align: center;
`

export const SelectedText = styled.span`
  font-weight: 800;
  color: ${({ theme }) => theme.selection};
`

export const ButtonContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    width: 1.5rem;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const TitleText = styled.span`  
  font-family: "BebasNeue";
  font-size: 50px;
  line-height: 1;
  letter-spacing: 1px;
  margin: 0;
  text-align: center;
`

export const ButtonHolder = styled.div`
  display: flex;
  width: 200px;
  height: 90px;
`

export const ButtonText = styled.p`
  font-size: 36px;
  margin: 0;
  line-height: 1;
  white-space: new-line;
  text-transform: none; !important
`

export const Content = styled.span`
  font-family: "BebasNeue";
  font-size: 2rem;
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;  
`
